import { init, thumbnailDecorator, waitForElement } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig, checkPageType } from "./config"
import { unbindOriginalSearch, waitForAttribute, isUsaFromDOM } from "./helpers.js"

import "./styles/index.css"

let inputSelector;
let formSelector;

// if(window.innerWidth < 1025) {
//     inputSelector = "#menu .form-custom-search #search_query";
//     formSelector = "nav.navUser .form-custom-search";
// } else {
//     inputSelector = "#quickSearch .form-custom-search #search_query";
//     formSelector = "#menu .form-custom-search";
// }
inputSelector = "#menu .form-custom-search #search_query";
// console.log(inputSelector, formSelector);


unbindOriginalSearch(inputSelector);
// FIXME eagerly calling this that early is risky, can it be delayed?
const isBrandPage = checkPageType();

// checkPageType().then(isBrandPage => {
    init({
        ...window.nostoTemplatesConfig,
        serpComponent: Serp,
        historyComponent: History,
        autocompleteComponent: Autocomplete,
        categoryComponent: Category,
        inputCssSelector: inputSelector,
        contentCssSelector: "#main-content",
        // formCssSelector: formSelector,
        hitDecorators: [
            thumbnailDecorator({ size: "9" })
        ],
        serpUrlMapping: {
            query: "search_query",
            // query: "q",
            "products.filter": "filter",
            "products.page": "page",
            "products.sort": "sort"
        },
        // Uncomment to redirect to search page instead of rendering on the same page
        serpPath: '/shop-all/',
    
        // Uncomment to redirect to search page instead of rewriting browser history
        serpPathRedirect: true,
        serpQuery: {
            products: {
                // fields: [
                //     "productId",
                //     "url",
                //     "name",
                //     "imageUrl",
                //     "imageHash",
                //     "thumbUrl",
                //     "description",
                //     "brand",
                //     "availability",
                //     "price",
                //     "priceText",
                //     "listPrice",
                //     "ratingValue",
                //     "reviewCount"
                //     'customFields.key', 'customFields.value'
                // ],
                facets: ["*"],
                size: defaultConfig.serpSize,
                from: 0
            }
        },
        autocompleteQuery: {
            products: {
                // fields: [
                //     "productId",
                //     "url",
                //     "name",
                //     "imageUrl",
                //     "thumbUrl",
                //     "brand",
                //     "availability",
                //     "price",
                //     "priceText",
                //     "listPrice",
                //     "ratingValue",
                //     "reviewCount"
                // ],
                size: defaultConfig.autocompleteProductsSize
            },
            keywords: {
                fields: ["keyword", "_highlight.keyword"],
                size: defaultConfig.autocompleteKeywordsSize,
                facets: ["*"]
            }
        },
        compressUrlParameters: true,
        fallback: true,
        // serpRenderDelay: () => {
        //     return waitForElement({
        //       selector: '.nosto_page_type',
        //       timeout: 1500
        //     })
        //  },
        //  serpRenderDelay: () => {
        //     return waitForAttribute('body', 'data-page-type', 'brand', 3, 500)
        //  },
        //  serpRenderDelay: () => {
        //     return waitForText('.nosto_page_type', 'category', 3, 800)
        //  },
        // // Uncomment for Category Merchandising
        // categoryCssSelector: '#main-content > .container-full > .page.custom-category',
        categoryCssSelector: '#nostoCategoryPage',
        // categoryCssSelector: '#main-content > .container > .page',
        categoryQuery() {
            return {
                name: 'serp',
                products: {
                    categoryId: this.categoryId(),
                    categoryPath: this.categoryPath(),
                    size: defaultConfig.serpSize,
                    from: 0,
                }
            }
        },
        queryModifications(query, pageType) {
            const isUsa = isUsaFromDOM();
            
            // const localQuery = {
            //     ...query,
            //     products: {
            //         ...query.products,
            //         filter: [
            //             ...(query.products?.filter ?? []),
            //             isUsa 
            //                 ? { 
            //                     "field": "tags2", 
            //                     "value": ["custom_availability:US", "custom_availability:us", "custom_availability=US"] 
            //                 } 
            //                 : { 
            //                     "not": {
            //                         "field": "tags2", 
            //                         "value": ["custom_availability:US", "custom_availability:us", "custom_availability=US"]
            //                     }
            //                 }
            //         ]
            //     }
            // };
            const localQuery = {
                ...query,
                products: {
                    ...query.products,
                    filter: [
                        ...(query.products?.filter ?? []),
                        ...(isUsa ? [] : [{ 
                            "not": {
                                "field": "tags2", 
                                "value": ["custom_availability:US", "custom_availability:us", "custom_availability=US"]
                            }
                        }])
                    ]
                }
            };

            if (pageType !== "category" || !isBrandPage) {
                return localQuery;
            }
    
            // FIXME this should be taken from brand tagging and not be pulled from the DOM
            const currentBrand = (document.querySelector("h1").textContent ?? "").trim()
            const additions = currentBrand ? { categoryPath: "shop all" } : {}

            return {
                ...localQuery,
                products: {
                    ...localQuery.products,
                    // categoryId: undefined,
                    // categoryPath: undefined,
                    ...additions,
                    filter: [
                        ...localQuery.products?.filter ?? [],
                        {
                            field: "brand",
                            value: [currentBrand]
                        },
                    ]
                }
            }
        },
    }).then(()=>{
        const nativeInput = document.querySelector(inputSelector);
        const bodyEl = document.body;
        if(nativeInput && bodyEl){
            nativeInput.addEventListener('focus', ()=>{
                bodyEl.classList.add("ns-ac-show");
            })
            // nativeInput.addEventListener('blur', (event)=>{
            //     console.log(event.currentTarget);
            //     bodyEl.classList.remove("ns-ac-show");
            // })
            bodyEl.addEventListener('click', (e)=>{
                if(e.target.closest('.ns-autocomplete') === null){
                    bodyEl.classList.remove("ns-ac-show");
                }
            })
        }
        const asyncFunc = async () => {
            const api = await new Promise(nostojs);
            // console.log("PageType is " + api.pageTagging().pageType)
        }
        asyncFunc();
        // const header = document.querySelector(".navPages-container.custom-navPages-container");
        // header.addEventListener('click', (e)=>{
        //     e.preventDefault();
        //     e.stopPropagation();
        //     console.log("header click")
        // })
        // console.log(document.querySelector("h1").innerHTML);
    })
// })

